import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'durationFormat'
})
export class DurationFormatPipe implements PipeTransform {
  transform(isoOrSeconds: string): string {
    if (!isoOrSeconds) return '00:00:00';

    let totalSeconds: number;

    // Prüfen, ob es eine reine Zahl ist (Sekunden)
    if (/^\d+$/.test(isoOrSeconds)) {
      totalSeconds = parseInt(isoOrSeconds, 10);
    } else {
      // ISO 8601 Duration parsen
      const regex = /PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;
      const match = isoOrSeconds.match(regex);

      if (!match) return '00:00:00';

      const hours = parseInt(match[1] || '0', 10);
      const minutes = parseInt(match[2] || '0', 10);
      const seconds = parseInt(match[3] || '0', 10);

      totalSeconds = hours * 3600 + minutes * 60 + seconds;
    }

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
}
